export default __webpack_public_path__ + "img/92bdb161cb62a9bb6be4ac5a046fea9b.png";